// Resources hub index (site-architecture hub; not one of the 92 keyword pages)
const pages = [
  {
    slug: '/resources/',
    category: 'Hub', tier: 'Hub',
    name: 'Recovery Housing Resources',
    primaryKeyword: 'Recovery Housing Resources',
    keywords: ['recovery housing resources', 'sober living guide', 'recovery housing education'],
    title: 'Recovery Housing Resources & FAQ | PGSRH Lehigh Valley, PA',
    description: 'Educational guides to recovery housing \u2014 what it is, how it works, house rules, benefits, and FAQs \u2014 from PGSRH in the Lehigh Valley, PA. Learn before you decide.',
    blurb: 'Guides and FAQs about recovery housing and sober living.',
    heroSubtitle: 'Clear, honest guides to recovery housing \u2014 understand how it works before you decide.',
    intro: [
      'Our resources section brings together plain-language guides about recovery housing and sober living. Whether you\u2019re new to the idea or comparing options for a loved one, these pages answer the questions people ask most.',
      'None of this is clinical advice \u2014 it\u2019s practical education about what recovery housing is and how PGSRH homes work.',
    ],
    whoFor: [
      'People new to recovery housing',
      'Families researching options for a loved one',
      'Individuals preparing to apply',
      'Referral partners looking for clear explanations',
    ],
    sections: [
      { h: 'Start with the basics', p: [
        'If you\u2019re just getting oriented, begin with what recovery housing is and how it compares to sober living. From there, explore the benefits, typical house rules, and what daily life and the first week look like.',
        'Each guide links back to our homes and application so you can move from learning to action whenever you\u2019re ready.',
      ] },
      { h: 'Have a specific question?', p: [
        'Our recovery housing FAQ gathers common questions \u2014 including funding \u2014 in one place. If you don\u2019t find your answer, contact PGSRH and we\u2019ll help.',
        'You can also explore our locations, gender-specific hubs, and funding options.',
      ] },
    ],
    faqs: [
      { q: 'What will I learn in these resources?', a: 'What recovery housing is, how it differs from sober living, its benefits, typical house rules, daily life, length of stay, and how to choose the right home.' },
      { q: 'Is this medical or clinical advice?', a: 'No. These are practical educational guides. PGSRH provides recovery housing, not clinical services.' },
      { q: 'Where do I go with more questions?', a: 'Start with our recovery housing FAQ, or contact PGSRH directly.' },
    ],
    related: [
      '/what-is-recovery-housing/', '/recovery-housing-vs-sober-living/', '/benefits-of-recovery-housing/',
      '/rules-of-a-recovery-home/', '/first-week-recovery-house/', '/how-long-stay-recovery-housing/',
      '/choosing-recovery-residence/', '/life-in-recovery-housing/', '/recovery-housing-faq/',
    ],
    funding: false,
  },
];

export default pages;
